var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.7998H4C2.8976 1.7998 2 2.60692 2 3.5998V14.3998C2 15.3927 2.8976 16.1998 4 16.1998H16C17.1024 16.1998 18 15.3927 18 14.3998V3.5998C18 2.60692 17.1024 1.7998 16 1.7998ZM17.2 3.5998V4.6798H10.4V2.5198H16C16.6616 2.5198 17.2 3.00436 17.2 3.5998ZM4 2.5198H9.6V4.6798H2.8V3.5998C2.8 3.00436 3.3384 2.5198 4 2.5198ZM2.8 14.3998V5.3998H9.6V15.4798H4C3.3384 15.4798 2.8 14.9952 2.8 14.3998ZM16 15.4798H10.4V5.3998H17.2V14.3998C17.2 14.9952 16.6616 15.4798 16 15.4798Z",
    fill: "#3B78CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7999 8.99979H7.1999C7.4207 8.99979 7.5999 8.83851 7.5999 8.63979C7.5999 8.44107 7.4207 8.27979 7.1999 8.27979H4.7999C4.5791 8.27979 4.3999 8.44107 4.3999 8.63979C4.3999 8.83851 4.5791 8.99979 4.7999 8.99979Z",
    fill: "#3B78CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1999 10.4399H4.7999C4.5791 10.4399 4.3999 10.6012 4.3999 10.7999C4.3999 10.9987 4.5791 11.1599 4.7999 11.1599H7.1999C7.4207 11.1599 7.5999 10.9987 7.5999 10.7999C7.5999 10.6012 7.4207 10.4399 7.1999 10.4399Z",
    fill: "#3B78CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1999 12.5996H4.7999C4.5791 12.5996 4.3999 12.7609 4.3999 12.9596C4.3999 13.1583 4.5791 13.3196 4.7999 13.3196H7.1999C7.4207 13.3196 7.5999 13.1583 7.5999 12.9596C7.5999 12.7609 7.4207 12.5996 7.1999 12.5996Z",
    fill: "#3B78CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1999 8.27979H12.7999C12.5791 8.27979 12.3999 8.44107 12.3999 8.63979C12.3999 8.83851 12.5791 8.99979 12.7999 8.99979H15.1999C15.4207 8.99979 15.5999 8.83851 15.5999 8.63979C15.5999 8.44107 15.4207 8.27979 15.1999 8.27979Z",
    fill: "#3B78CE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1999 10.4399H12.7999C12.5791 10.4399 12.3999 10.6012 12.3999 10.7999C12.3999 10.9987 12.5791 11.1599 12.7999 11.1599H15.1999C15.4207 11.1599 15.5999 10.9987 15.5999 10.7999C15.5999 10.6012 15.4207 10.4399 15.1999 10.4399Z",
    fill: "#3B78CE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1999 12.5996H12.7999C12.5791 12.5996 12.3999 12.7609 12.3999 12.9596C12.3999 13.1583 12.5791 13.3196 12.7999 13.3196H15.1999C15.4207 13.3196 15.5999 13.1583 15.5999 12.9596C15.5999 12.7609 15.4207 12.5996 15.1999 12.5996Z",
    fill: "#3B78CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIcon);
export default __webpack_public_path__ + "static/media/tableIcon.bfce4d896da7ffd3f304d9df01e5a850.svg";
export { ForwardRef as ReactComponent };